// master namespace for the application
var veritracks = {};
